/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaChecklistJumpList.tsx
 * FILE_ID: JOBHUB-QA-CHECKLIST-JUMP-001
 * PURPOSE: Checklists grouped under every area. Current area is first and open.
 */
import { useState } from 'react'

export type QaJumpChecklist = {
  id: string
  name: string
  areaId: string
  areaName: string
}

export function QaChecklistJumpList({
  rows,
  currentAreaId,
  currentChecklistId,
  onPick,
}: {
  rows: readonly QaJumpChecklist[]
  currentAreaId: string | null
  currentChecklistId: string | null
  onPick: (areaId: string, checklistId: string) => void
}) {
  const [opened, setOpened] = useState<Record<string, boolean>>({})
  const [closed, setClosed] = useState<Record<string, boolean>>({})
  const areaIds: string[] = []
  const byArea = new Map<string, { name: string; rows: QaJumpChecklist[] }>()
  for (const row of rows) {
    const bucket = byArea.get(row.areaId)
    if (bucket) bucket.rows.push(row)
    else {
      areaIds.push(row.areaId)
      byArea.set(row.areaId, { name: row.areaName, rows: [row] })
    }
  }
  const ordered = [
    ...areaIds.filter((id) => id === currentAreaId),
    ...areaIds.filter((id) => id !== currentAreaId),
  ]
  return (
    <div>
      {ordered.map((areaId) => {
        const bucket = byArea.get(areaId)
        if (!bucket) return null
        const isCurrent = areaId === currentAreaId
        const open = isCurrent ? closed[areaId] !== true : opened[areaId] === true
        return (
          <div key={areaId}>
            <button
              type="button"
              className="flex min-h-[44px] w-full items-center px-3 text-left text-xs font-semibold uppercase text-muted-foreground"
              aria-expanded={open}
              onClick={() => {
                if (isCurrent) setClosed((current) => ({ ...current, [areaId]: open }))
                else setOpened((current) => ({ ...current, [areaId]: !open }))
              }}
            >
              {bucket.name}
            </button>
            {open ? bucket.rows.map((row) => (
              <button
                key={row.id}
                type="button"
                className="flex min-h-[44px] w-full items-center px-4 text-left text-sm"
                aria-current={row.id === currentChecklistId ? 'true' : undefined}
                onClick={() => onPick(row.areaId, row.id)}
              >
                {row.name}
              </button>
            )) : null}
          </div>
        )
      })}
    </div>
  )
}
